/* eslint-disable react/style-prop-object */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedPlural } from 'react-intl';
import Truncate from 'react-truncate';
import cn from 'classnames';

// Components
import { Row, Col, Container } from 'reactstrap';
import Price from 'components/atoms/Price';
import ParseHTML from 'components/atoms/ParseHTML';

// Constants
import { SERVICES_TYPE } from 'constants/services';
import { APP_NAMES } from 'constants/appName';

// Utils
import { canPriceCapApplyToPackage } from 'utils/prices';

import './ModalServicesList.scss';
const ns = 'services-modal';

class ModalServicesList extends Component {
  getServiceRow(service, type) {
    const {
      id,
      name,
      price,
      discountedPrice,
      promotion,
      showPrice,
      priceCaption,
      operationItemId // Declined service use operationItemId as unique identifier
    } = service;
    const servicePrice = promotion ? discountedPrice : price;
    const displayPriceCaption = !!priceCaption;
    return (
      <Row
        key={operationItemId || id}
        className={`${ns}__service-row`}
        noGutters
      >
        <Col xs={9} className={`${ns}__service-name`}>
          <Truncate lines={2}>
            <ParseHTML html={name} />
          </Truncate>
        </Col>
        <Col xs={'3'} className={`${ns}__col`}>
          {promotion && (
            <span
              className={`${ns}__service-price ${ns}__service-price--promotion`}
            >
              <Price
                type={type}
                value={
                  type === SERVICES_TYPE.MENU
                    ? showPrice
                      ? price
                      : null
                    : price
                }
              />
            </span>
          )}
          <span className={`${ns}__service-price`}>
            <Price
              type={type}
              value={
                type === SERVICES_TYPE.MENU
                  ? showPrice
                    ? servicePrice
                    : null
                  : servicePrice
              }
              displayCaption={displayPriceCaption}
            />
          </span>
        </Col>
        <Col xs="12">
          {priceCaption && (
            <p className={`${ns}__price-caption`}>*{priceCaption}</p>
          )}
        </Col>
      </Row>
    );
  }

  render() {
    const {
      serviceList,
      apptServicePoint,
      individualTotalPrice,
      apptMenuType,
      servicesCount,
      intl,
      appName,
      className
    } = this.props;
    const { services, description, totalPrice, discountedPrice } = apptMenuType;
    const { MENU, ALACARTE } = SERVICES_TYPE;
    const {
      discountedPrice: individualDiscountedPrice,
      price: individualPrice
    } = individualTotalPrice;
    const totalPriceHasPromotion =
      individualPrice !== individualDiscountedPrice;
    const totalPriceMenuHasPromotion = totalPrice !== discountedPrice;
    const isSelfCheckIn = appName === APP_NAMES.SELF_CHECK_IN;
    const servicesLabelSingular = isSelfCheckIn
      ? 'c8.self.check.in.common.service.singular'
      : 'c8.common.service.singular';
    const servicesLabelPlural = isSelfCheckIn
      ? 'c8.self.check.in.common.service.plural'
      : 'c8.common.service.plural';
    const listClassName = cn(ns, className);
    const applyPriceCap =
      apptServicePoint && canPriceCapApplyToPackage(apptServicePoint.menuType);

    return (
      <Container className={listClassName}>
        {serviceList.length > 0 && (
          <Row className={`${ns}__title ${ns}__service-row`} noGutters>
            <Col xs={'9'}>
              <FormattedPlural
                one={intl.formatMessage(
                  {
                    id: servicesLabelSingular
                  },
                  { servicesCount }
                )}
                other={intl.formatMessage(
                  {
                    id: servicesLabelPlural
                  },
                  { servicesCount }
                )}
                value={servicesCount}
              >
                {msg => msg}
              </FormattedPlural>
            </Col>
            <Col xs={'3'}>
              {totalPriceHasPromotion && (
                <span
                  className={`d-block ${ns}__service-price ${ns}__service-price--promotion`}
                >
                  <Price type={ALACARTE} value={individualPrice} />
                </span>
              )}
              <span className={`d-block ${ns}__service-price`}>
                <Price
                  type={ALACARTE}
                  value={
                    totalPriceHasPromotion
                      ? individualDiscountedPrice
                      : individualPrice
                  }
                />
              </span>
            </Col>
          </Row>
        )}
        {serviceList.map(service => this.getServiceRow(service, ALACARTE))}
        {apptServicePoint && (
          <Row className={`${ns}__title ${ns}__service-row`} noGutters>
            <Col xs={'9'}>{description}</Col>
            <Col xs={'3'} className={`${ns}__service-price`}>
              {totalPriceMenuHasPromotion && (
                <span
                  className={`d-block ${ns}__service-price ${ns}__service-price--promotion`}
                >
                  <Price type={MENU} value={totalPrice} />
                </span>
              )}
              <span className={`d-block ${ns}__service-price`}>
                <Price
                  type={MENU}
                  value={
                    totalPriceMenuHasPromotion ? discountedPrice : totalPrice
                  }
                  displayCaption={applyPriceCap}
                />
              </span>
            </Col>
            {applyPriceCap && (
              <Col className={`${ns}__capped-price`}>
                {'* '}
                {intl.formatMessage({
                  id: 'c8.service.capped.pricing.applied',
                  defaultMessage: 'Capped Pricing Applied'
                })}
              </Col>
            )}
          </Row>
        )}
        {apptServicePoint &&
          services.map(service => this.getServiceRow(service, MENU))}
      </Container>
    );
  }
}

ModalServicesList.propTypes = {
  appName: PropTypes.string.isRequired,
  apptMenuType: PropTypes.object.isRequired,
  apptServicePoint: PropTypes.object,
  className: PropTypes.string,
  individualTotalPrice: PropTypes.object,
  intl: PropTypes.object,
  promotionServices: PropTypes.array,
  serviceList: PropTypes.array.isRequired,
  servicesCount: PropTypes.number,
  tellusmoreSvcId: PropTypes.string
};

export default injectIntl(ModalServicesList);



// WEBPACK FOOTER //
// ./src/components/molecules/ModalServicesList/ModalServicesList.js